/**
 * Legacy PartnersApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.partnersApi`) keep resolving.
 *
 * The actual `PartnersApiService` is now exposed indirectly: the Angular 18
 * `ApiService` facade (registered as the downgraded `'ApiService'` in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts) exposes
 * `apiService.partners` as an `inject(PartnersApiService)` Angular 18 class.
 * The actual implementation lives at
 *   apps/b2b-frontend/app/core/api/partners/partners-api.service.ts
 *
 * Do NOT register `.service('PartnersApiService', ...)` here — nothing
 * consumes it directly anymore.
 */
angular.module('acme.common.service.partnersApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder',
]);
